import ValoracionesClass from "src/app/model/api/datos/valoracionesClass";
import DatabaseTable from "src/app/model/database/generic/databaseTable";

export default class ValoracionesTable extends DatabaseTable<ValoracionesClass> {

    public async getAll(): Promise<ValoracionesClass[]> {
        return await this.GetAllRecords()
    }

    public async getById(Id: number): Promise<ValoracionesClass> {
        let records = await this.GetRecordsById(0, 1, Id, Id)
        if (records.length) {
            return records[0]
        }
        return null
    }

    public async update(record: ValoracionesClass): Promise<void> {
        await this.UpdateRecord(record)
    }

    public async delete(record: ValoracionesClass): Promise<void> {
        if (!record?.Id) return
        await this.DeleteRecord(record.Id)
    }

    public async deleteById(Id: string): Promise<void> {
        await this.DeleteRecord(Id)
    }

}